if (!customElements.get("floating-add-to-cart")) {
  customElements.define(
    "floating-add-to-cart",
    class FloatingAddToCart extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[type="button"]');
        this.buttonText = this.button?.querySelector("span");
        this.loadingSpinner = this.button?.querySelector(".loading__spinner");
        this.mediaQuery = window.matchMedia("(max-width: 749px)");
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.updateVisibility = this.updateVisibility.bind(this);
        this.syncButtonState = this.syncButtonState.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest("product-info");
        this.mainButton = document.getElementById(this.dataset.targetButtonId);
        if (!this.button || !this.mainButton) return;

        this.button.addEventListener("click", this.handleButtonClick);
        this.mediaQuery.addEventListener("change", this.handleMediaChange);

        this.buttonObserver = new MutationObserver(this.syncButtonState);
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ["aria-disabled", "disabled", "class"],
          childList: true,
          characterData: true,
          subtree: true,
        });

        this.intersectionObserver = new IntersectionObserver(
          this.updateVisibility,
          { threshold: 0 },
        );
        this.intersectionObserver.observe(this.mainButton);

        this.syncButtonState();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this.handleButtonClick);
        this.mediaQuery.removeEventListener("change", this.handleMediaChange);
        this.buttonObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.productInfo?.classList.remove(
          "product-info--floating-add-to-cart-visible",
        );
      }

      handleButtonClick() {
        if (
          this.mainButton.disabled ||
          this.mainButton.getAttribute("aria-disabled") === "true"
        )
          return;
        this.mainButton.click();
      }

      handleMediaChange() {
        this.updateVisibility();
      }

      updateVisibility() {
        if (!this.mainButton) return;

        const buttonRect = this.mainButton.getBoundingClientRect();
        const isPastMainButton = buttonRect.bottom <= 0;
        const shouldShow = this.mediaQuery.matches && isPastMainButton;

        this.toggleAttribute("hidden", !shouldShow);
        this.productInfo?.classList.toggle(
          "product-info--floating-add-to-cart-visible",
          shouldShow,
        );
      }

      syncButtonState() {
        if (!this.button || !this.mainButton) return;

        const sourceText = this.mainButton
          .querySelector("span")
          ?.textContent?.trim();
        const isLoading = this.mainButton.classList.contains("loading");
        const isDisabled =
          this.mainButton.disabled ||
          this.mainButton.getAttribute("aria-disabled") === "true";

        if (sourceText && this.buttonText)
          this.buttonText.textContent = sourceText;

        this.button.disabled = isDisabled;
        this.button.toggleAttribute("aria-disabled", isDisabled);
        this.button.classList.toggle("loading", isLoading);
        this.loadingSpinner?.classList.toggle("hidden", !isLoading);
      }
    },
  );
}
